namespace TabAurous.Common {
    export interface CommonProductBOM {
        BomId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        BOMProductId?: number;
        BOMAttributeId?: number;
        Lab?: string;
        CertificateNo?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        CostMethodId?: number;
        SettingId?: number;
        BomRate?: number;
        BomAmount?: number;
        Purity?: number;
        PureWeight?: number;
        StdPurity?: number;
        Remarks?: string;
        ProductTypeCode?: string;
        ItemTypeId?: number;
        ItemType?: string;
        CategoryId?: number;
        CategoryCode?: string;
        SubCategoryId?: number;
        SubCategoryCode?: string;
        KaratId?: number;
        KaratCode?: string;
        MetalColorId?: number;
        MetalColorCode?: string;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        StoneSizeId?: number;
        StoneSizeCode?: string;
        BrandId?: number;
        BrandCode?: string;
        CollectionId?: number;
        CollectionCode?: string;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        ShapeId?: number;
        ShapeCode?: string;
        SieveId?: number;
        SieveCode?: string;
        GroupSieveId?: number;
        GroupSieveCode?: string;
        QualityId?: number;
        QualityCode?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        StampId?: number;
        StampCode?: string;
        MetalId?: number;
        MetalCode?: string;
        Setting?: string;
        StoneCutId?: number;
        StoneCutCode?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneTable?: string;
        StoneDepth?: string;
        HSN?: string;
        TaxCode?: string;
        Length?: string;
        Width?: string;
        Depth?: string;
        Volume?: number;
        TextureCode?: string;
        Parts?: any;
    }
}
